import Query from '../../components/Report';

const query = ({ offset = 0 }) => new Query('categoryTopPages', { offset });
export const getAllQuery = () => new Query('categoryTopPagesAll');

export default query;
